import { useCallback } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Button from '@zenbusiness/zui/Button';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import { useNavigate } from 'react-router-dom';

import { MFE_PATHS } from '#client/constants/paths';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useDashboardPath } from '#client/hooks/useDashboardPath';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';

const InvoicingIcon = (
  <SharedAsset
    alt=""
    height={15}
    src="/s2/icon/receipt-list-outline.svg"
    width={15}
  />
);

export default function InvoicingButton() {
  const { isDisable } = useDisableDashboardContext();
  const navigate = useNavigate();
  const { entitlements } = useConstBusinessEntityUuid();
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const path = useDashboardPath(MFE_PATHS.INVOICING);

  const hasBanking = entitlements.has('banking');
  const hasMoneyPro = entitlements.has('money_pro');

  const buttonPressedTracker = useButtonPressedCallback({
    elementName: 'invoicing_button_on_banking_dashboard',
    elementText: 'Invoices',
    appPageName: 'active_banking_dashboard'
  });

  const handleClick = useCallback(() => {
    buttonPressedTracker();

    navigate(path);
  }, [buttonPressedTracker, navigate, path]);

  if (hasBanking && !hasMoneyPro) {
    return (
      <Button
        disabled={isDisable}
        icon={!isMobile ? InvoicingIcon : undefined}
        onClick={handleClick}
        size="small"
        variant="outlined"
      >
        Invoices
      </Button>
    );
  }

  return null;
}
